import { render } from "./IndexSzzy.vue?vue&type=template&id=4508a511&scoped=true"
import script from "./IndexSzzy.vue?vue&type=script&lang=js"
export * from "./IndexSzzy.vue?vue&type=script&lang=js"

import "./IndexSzzy.vue?vue&type=style&index=0&id=4508a511&scoped=true&lang=css"

import exportComponent from "F:\\jenkins\\data\\workspace\\ZYZB\\zyzb-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4508a511"]])

export default __exports__